<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription Module</a></li>
      <li class="breadcrumb-item active" aria-current="page">Subscription Media</li>
    </ol>
  </nav>
</div>

<div class="container mt-1 themeTblReso">
  <div class="assignFilterBar">
    <div class="filterItem" *ngIf="companyID==0">
      <select name="company" class="form-control formstyle" [ngModel]="selectedCompany" (ngModelChange)="onCompanyChange($event)">
        <option value="">Select Company Name</option>
        <ng-container *ngFor="let userObj of getCompanyobj">
          <option *ngIf="userObj.dbstatus == true" value={{userObj.customer_id}}>
            {{ userObj.customer_company_name }}
          </option>
        </ng-container>
      </select>
    </div>
    <div class="filterItem filterSearch">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text cyan lighten-2" id="basic-text1"><i class="fa fa-search text-white"
              aria-hidden="true"></i></span>
        </div>
        <input class="form-control" type="text" placeholder="Search" aria-label="Search" #searchText/>
      </div>
    </div>
    <div class="filterAction">
      <input type="button" value="Reset" class="custbtn-outline" (click)="resetFilters()" />
      <input type="button" value="Add New" class="custbtn" routerLink="/corporate/create-media-subscription" />
    </div>
  </div>
  <div class="tblPrt">
    <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <th (click)="setOrder('media_name')" style="cursor: pointer">Media Name <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
        <th>Media Label</th>
        <th>Media Point</th>
        <th *ngFor="let col of planColumns">{{col.title}}</th>
        <th>Campaign</th>
        <th (click)="setOrder('createdon')" style="cursor: pointer">
          Created On <i class="fa fa-sort text-black" aria-hidden="true"></i>
        </th>
        <th>Actions</th>
      </tr>
      <tr *ngFor="let subscription of mediaSubData">
        <td>{{subscription?.media_name | titlecase}}</td>
        <td>{{subscription?.media_label}}</td>
        <td>{{subscription?.point}}</td>
        <td *ngFor="let col of planColumns">{{ planPointDisplay(subscription, col.slug_title) }}</td>
        <td>{{subscription?.is_campaign ? 'Yes' : 'No'}}</td>
        <td>{{subscription?.createdon | date: "mediumDate"}}</td>
        <td>
          <div class="actBtn">
            <i *ngIf='isEdit' class="fa fa-edit mr-1 linkForce" (click)="editPost(subscription.id)"></i>
            <i *ngIf='isEdit' class="fa fa-trash mr-1 linkForce"
              (click)="delSubscription($event, subscription.id)"></i>
            <mat-slide-toggle *ngIf='isEdit' class="my-slider" [checked]="subscription.isactive"
              (click)="updateStatus($event, subscription.id, subscription.isactive)">
            </mat-slide-toggle>

          </div>
        </td>
      </tr>
    </table>
    <div *ngIf="mediaSubTotal == 0" style="text-align: center">
      <p>No Result Available</p>
    </div>
    <div class="mt-2 text-center difPagination" *ngIf="mediaSubTotal > slCatLimit">
      <ngb-pagination [collectionSize]="mediaSubTotal" [(page)]="slCatPage" [maxSize]="2" [rotate]="true" (pageChange)="getSubscriptionList(slCatPage=$event)" aria-label="Custom pagination">
        <ng-template ngbPaginationPrevious>Prev</ng-template>
        <ng-template ngbPaginationNext>Next</ng-template>
      </ngb-pagination>
    </div>
  </div>
</div>
